import { NavParams, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'search.html',
})
export class ChaseSearchPage {
    paras = {
        startDate: '',
        endDate: '',
        state: '',
        userName: '',
        pageIndex: 1,
        pageSize: 30,
    };
    states = [];

    constructor(
        private navpars: NavParams,
        private viewCtrl: ViewController
    ) {
        this.paras = this.navpars.get('paras');
        this.states = this.navpars.get('states');
    }

    //确认按钮
    //TQQ 2018-01-26
    okSearch() {
        this.dismiss(this.paras);
    }

    //取消按钮
    //TQQ 2018-02-26
    dismiss(data?) {
        this.viewCtrl.dismiss(data);
    }




}


// WEBPACK FOOTER //
// ./src/pages/vrchasereport/search.ts